const keys = {
  'prazoPagamento.descricao': {
    description: 'Prazo de pagamento',
    isEnum: false,
    isCurrency: false,
    isFloat: false,
  },
  total: {
    description: 'Total',
    isEnum: false,
    isCurrency: true,
    isFloat: false,
  },
  valorFrete: {
    description: 'Valor sem ICMS',
    isEnum: false,
    isCurrency: true,
    isFloat: false,
  },
  formaPagamento: {
    description: 'Forma de pagamento',
    isEnum: true,
    isCurrency: false,
    isFloat: false,
    enumName: 'FormaPagamento',
  },
  prazoEntrega: {
    description: 'Prazo de entrega',
    isEnum: false,
    isCurrency: false,
    isFloat: false,
  },
  observacao: {
    description: 'Observação',
    isEnum: false,
    isCurrency: false,
    isFloat: false,
  },
  icms: {
    description: 'ICMS',
    isEnum: false,
    isCurrency: false,
    isFloat: true,
    type: 'PERCENTUAL',
    suffix: ' %',
  },
  tipoAplicacaoIcms: {
    description: 'Aplicação ICMS',
    isEnum: true,
    isCurrency: false,
    isFloat: false,
    enumName: 'AplicacaoImposto',
  },
};

const values = Object.keys(keys)
  .map(key => keys[key]);

export default {
  keys,
  values,
};
